import { connect } from 'react-redux'
import { loadAgentsPage } from 'Actions/pages'
import { reloadAgentsData } from 'Modules/agent/actions'
import { setTargetComponent } from 'Modules/lookups/actions'

import AgentGrid from './AgentGrid'

export default connect(
  state => ({
    isMobile: state.app.isMobile,
    isFetching: state.agents.isFetching,
    agents: state.agents.agents,
    reduxLocation: state.location,
    userCurrentArea: state.userDefaults.userCurrentArea,
  }),
  {
    loadAgentsPage,
    reloadAgentsData,
    setTargetComponent,
  },
)(AgentGrid)

